<div (click)="cancelClicked()" id="locationChangesDialog" appDraggable dragTarget="#locationChangesDialog" dragHandle="#locationChangesDialogHeader" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
	<div (click)="$event.stopPropagation()" class="modal-dialog" role="document">
		<div class="modal-content">
			<div id="locationChangesDialogHeader" class="modal-header">
				<h4>Warning!</h4>
			</div>
			<div class="modal-body">
				<p>The current location contains changes that will be lost if you continue.</p>
			</div>
			<div class="modal-footer">
				<button (click)="cancelClicked()" type="button" class="btn btn-default pull-left" data-dismiss="modal">CANCEL</button>
				<button (click)="discardClicked()" type="button" class="btn btn-default">DISCARD CHANGES</button>
				<button (click)="saveClicked()" type="button" class="btn btn-primary">SAVE CHANGES</button>
			</div>
		</div>
	</div>
</div>